import React, {Component} from 'react'
import { Link } from 'react-router-dom';

export class Leftbar extends Component {
    render() {
        return (
            <div className="menu">
                <nav className="menu-principal ">
                    <ul className="nav justify-content-center">
                        <li className="nav-item">
                            <Link to="/" className="nav-link">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/about-me" className="nav-link">About me</Link>
                        </li>
                        <li className="nav-item">
                             <Link to="/projects" className="nav-link">Projects</Link>
                        </li>
                        <li>
                            <a href="https://jebusdoodles.wordpress.com/" className="nav-link">Blog</a>
                        </li>
                        <li className="nav-item dropdown">
                            <div className="dropbtn">
                                Art
                            </div>
                            <div className="dropdown-content">
                                <Link to="/illustration">Illustration</Link>
                                <Link to="/comic">Comic</Link>
                            </div>
                        </li>
                        <li className="nav-item">
                            <Link to="/contact" className="nav-link">Contact me</Link>
                        </li>
                    </ul>
                </nav>
            </div>
        )
    }
}

export default Leftbar;